/* InSPiration — carousel Sélection de Sasha, homepage only. */
(function(){
      document.querySelectorAll('[data-ibs-sasha-carousel]').forEach(function(section){
        if(section.dataset.ibsCarouselReady === 'true') return;
        section.dataset.ibsCarouselReady = 'true';
        var track = section.querySelector('[data-ibs-sasha-track]');
        var prev = section.querySelector('[data-ibs-sasha-prev]');
        var next = section.querySelector('[data-ibs-sasha-next]');
        var status = section.querySelector('[data-ibs-sasha-status]');
        var progress = section.querySelector('[data-ibs-sasha-progress]');
        if(!track) return;
        var cards = Array.prototype.slice.call(track.children);
        if(!cards.length) return;
        var ticking = false;
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        function nearestIndex(){
          var left = track.scrollLeft;
          var best = 0, distance = Infinity;
          cards.forEach(function(card,index){
            var d = Math.abs(card.offsetLeft - left);
            if(d < distance){distance=d;best=index;}
          });
          return best;
        }
        function update(){
          var index = nearestIndex();
          var max = Math.max(0,track.scrollWidth-track.clientWidth);
          if(status) status.textContent = (index+1)+' / '+cards.length;
          if(prev) prev.disabled = track.scrollLeft <= 4;
          if(next) next.disabled = track.scrollLeft >= max-4;
          if(progress){
            var ratio = cards.length <= 1 ? 1 : (index+1)/cards.length;
            progress.style.width = Math.max(12,ratio*100)+'%';
          }
          section.classList.toggle('is-static',max<=4);
          ticking=false;
        }
        function go(delta){
          var index = nearestIndex();
          var target = Math.max(0,Math.min(cards.length-1,index+delta));
          track.scrollTo({left:cards[target].offsetLeft,behavior:reduceMotion?'auto':'smooth'});
        }
        if(prev) prev.addEventListener('click',function(){go(-1);});
        if(next) next.addEventListener('click',function(){go(1);});
        track.addEventListener('scroll',function(){if(ticking) return;ticking=true;window.requestAnimationFrame(update);},{passive:true});
        if('ResizeObserver' in window) new ResizeObserver(update).observe(track);else window.addEventListener('resize',update,{passive:true});
        update();
      });
    })();
